import { render } from "./WebsiteClicks.vue?vue&type=template&id=d63171ca"
import script from "./WebsiteClicks.vue?vue&type=script&lang=js"
export * from "./WebsiteClicks.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__